module.exports = ".row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}\r\n\r\n.row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\ntd{\r\n    border: 1px solid #ddd;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/not-alloted-refund-form/not-alloted-refund-form.component.css
// module id = ./src/app/allocation/not-alloted-refund-form/not-alloted-refund-form.component.css
// module chunks = main